import Rails from 'rails-ujs';
import serverRedering from './server_rendering';

Rails.start();
